import { render, staticRenderFns } from "./EditStrategicQuestion.vue?vue&type=template&id=1d45ac89&scoped=true"
import script from "./EditStrategicQuestion.vue?vue&type=script&lang=js"
export * from "./EditStrategicQuestion.vue?vue&type=script&lang=js"
import style0 from "./EditStrategicQuestion.vue?vue&type=style&index=0&id=1d45ac89&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d45ac89",
  null
  
)

export default component.exports